module.exports = __webpack_public_path__ + "static/media/vitalChat_21.eea87368.png";